import React from 'react';
import { motion } from 'framer-motion';

const WhatsAppButton: React.FC = () => {
  // WhatsApp number with country code (52 for Mexico) and city code (1 for mobile)
  const phoneNumber = '528118521080';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  // Inline SVG for the WhatsApp icon to avoid external dependencies
  const WhatsAppIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      className="w-8 h-8" // Removed text-white
      fill="currentColor"
      // Added green color to make it visible against the glass background
      style={{ color: '#128C7E' }}
    >
      <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 221.9-99.6 221.9-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.8 0-67.3-8.8-98.1-25.4l-7-4.1-73.4 19.3 19.7-71.5-4.5-7.3c-18.4-29.8-28.2-63.7-28.2-98.8 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.8-16.2-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
    </svg>
  );

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 flex items-center justify-center w-16 h-16 rounded-[2rem]"
      aria-label="Chat on WhatsApp"
      whileHover={{ scale: 1.1, rotate: 10 }}
      whileTap={{ scale: 0.9 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      // --- Added Glassmorphism Styles ---
      style={{
        // position: 'relative', <-- This was the issue, it has been removed.
        background: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(2px) saturate(180%)',
        WebkitBackdropFilter: 'blur(2px) saturate(180%)',
        border: '1px solid rgba(255, 255, 255, 0.8)',
        boxShadow: '0 8px 32px rgba(31, 38, 135, 0.2), inset 0 4px 20px rgba(255, 255, 255, 0.3)',
      }}
    >
      {/* --- Added div to simulate the ::after pseudo-element for extra gloss --- */}
      <div
        className="absolute top-0 left-0 w-full h-full -z-10 pointer-events-none"
        style={{
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '2rem',
          backdropFilter: 'blur(1px)',
          WebkitBackdropFilter: 'blur(1px)',
          boxShadow: 'inset -10px -8px 0px -11px rgba(255, 255, 255, 1), inset 0px -9px 0px -8px rgba(255, 255, 255, 1)',
          opacity: 0.6,
          filter: 'blur(1px) drop-shadow(10px 4px 6px black) brightness(115%)',
        }}
      />
      <WhatsAppIcon />
    </motion.a>
  );
};

export default WhatsAppButton;

